export default __webpack_public_path__ + "media/images/mailer/icon_file_download-805330718162a60bbb581ade04c0b251.png";